function refreshCartJS() {
  const cartSlide = document.querySelector('cart-slide');
  if (cartSlide) {
    if (cartSlide.refreshCart) cartSlide.refreshCart();
    // Open cart drawer if not active
    if (cartSlide.toggleCart && !cartSlide.classList.contains('active')) {
      cartSlide.toggleCart();
    }
  }
}

function customMiniCartRelatedProductAddToCart(id, quantity, openCart) {
  // Validate variant ID
  if (!id || id === '' || id === 'undefined' || id === 'null') {
    console.error('Invalid variant ID:', id);
    alert('Please select a product variant');
    return;
  }

  // Validate quantity
  if (!quantity || 1 > quantity || isNaN(quantity)) {
    console.error('Invalid quantity:', quantity);
    alert('Please enter a valid quantity');
    return;
  }

  const formData = {
    'items': [{
      'id': String(id), // Ensure ID is a string
      'quantity': parseInt(quantity, 10)
    }]
  };

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
        return response.json().then(err => {
            throw new Error(err.description || err.message || 'Failed to add to cart');
        });
    }
    return response.json();
  })
  .then(response => {
    // Refresh cart
    refreshCartJS();
    if (openCart) {
       // logic to open cart is handled in refreshCartJS usually, but we can force it
       const cartSlide = document.querySelector('cart-slide');
       if (cartSlide && !cartSlide.classList.contains('active') && cartSlide.toggleCart) {
           cartSlide.toggleCart();
       }
    }
  })
  .catch(function(error) {
    console.error('Add to cart error:', error);
    alert(error.message || error);
  });
}

function ajaxCartCall() {
    refreshCartJS();
}

function miniCartRefresh(openCart) {
    refreshCartJS();
}

/**
 * Non-plush: bundle removal only when the removed line has _original_unique_key (drop all lines whose orig or _unique_key matches).
 * Line has only _unique_key (no origin) → single-line remove, except Plus plush main when a tagged add-on shares that key.
 */
function plushCartTruthyProperty(val) {
  return val === true || val === 'true' || val === 1 || val === '1';
}

/** Free promo bandanas are synced by free-bandana-sync.js — never bundle-remove them here. */
function plushCartIsFreeBandanaGift(item) {
  var p = item && item.properties;
  return plushCartTruthyProperty(p && p._free_bandana_gift);
}

function plushCartBundleRemovalUpdates(cart, lineNumber) {
  if (!cart || !Array.isArray(cart.items)) return null;
  var lineNum = parseInt(String(lineNumber), 10);
  if (!lineNum || lineNum < 1 || lineNum > cart.items.length) return null;
  var target = cart.items[lineNum - 1];
  if (!target || !target.properties) return null;
  var tp = target.properties;
  var targetIsAddon =
    plushCartTruthyProperty(tp._accessories_product) || plushCartTruthyProperty(tp._rush_product);
  if (targetIsAddon) return null;

  var origOnTarget = String(tp._original_unique_key || '').trim();
  var ukOnTarget = String(tp._unique_key || '').trim();
  if (!origOnTarget && !ukOnTarget) return null;

  var lineIdx0 = lineNum - 1;
  function hasPlushTaggedLineWithKey(bundleKey) {
    return cart.items.some(function (item, j) {
      if (j === lineIdx0) return false;
      var p = item.properties || {};
      if (!plushCartTruthyProperty(p._accessories_product) && !plushCartTruthyProperty(p._rush_product)) {
        return false;
      }
      return String(p._unique_key || '').trim() === bundleKey;
    });
  }

  var bundleKey = '';
  var usePlushPath = false;
  if (origOnTarget) {
    bundleKey = origOnTarget;
    usePlushPath = hasPlushTaggedLineWithKey(bundleKey);
  } else {
    usePlushPath = hasPlushTaggedLineWithKey(ukOnTarget);
    if (!usePlushPath) {
      return null;
    }
    bundleKey = ukOnTarget;
  }

  var updates = {};
  if (usePlushPath) {
    cart.items.forEach(function (item, i) {
      if (plushCartIsFreeBandanaGift(item)) return;
      var p = item.properties || {};
      var l = i + 1;
      var orig = String(p._original_unique_key || '').trim();
      var uk = String(p._unique_key || '').trim();
      var isAddon =
        plushCartTruthyProperty(p._accessories_product) || plushCartTruthyProperty(p._rush_product);

      if (orig === bundleKey) {
        updates[String(l)] = 0;
      } else if (uk === bundleKey && isAddon) {
        updates[String(l)] = 0;
      } else if (uk === bundleKey && !isAddon && !orig) {
        updates[String(l)] = 0;
      }
    });
  } else {
    cart.items.forEach(function (item, i) {
      if (plushCartIsFreeBandanaGift(item)) return;
      var p = item.properties || {};
      var l = i + 1;
      var orig = String(p._original_unique_key || '').trim();
      var uk = String(p._unique_key || '').trim();
      if (orig === bundleKey || uk === bundleKey) {
        updates[String(l)] = 0;
      }
    });
  }
  return Object.keys(updates).length ? updates : null;
}

function plushCartBundleRemovalUpdatesByVariant(cart, variantId) {
  if (!cart || !Array.isArray(cart.items)) return null;
  var idx = -1;
  for (var i = 0; i < cart.items.length; i++) {
    if (String(cart.items[i].variant_id) === String(variantId)) {
      idx = i;
      break;
    }
  }
  if (idx < 0) return null;
  return plushCartBundleRemovalUpdates(cart, idx + 1);
}

function plushCartBundleRemovalLineKeys(cart, lineNumber) {
  var updates = plushCartBundleRemovalUpdates(cart, lineNumber);
  if (!updates || !cart.items) return [];
  return Object.keys(updates)
    .map(function (lineStr) {
      var i = parseInt(lineStr, 10) - 1;
      var item = cart.items[i];
      return item && item.key ? String(item.key) : null;
    })
    .filter(Boolean);
}

function plushCartBundleRemovalLineKeysByVariant(cart, variantId) {
  if (!cart || !Array.isArray(cart.items)) return [];
  var idx = -1;
  for (var i = 0; i < cart.items.length; i++) {
    if (String(cart.items[i].variant_id) === String(variantId)) {
      idx = i;
      break;
    }
  }
  if (idx < 0) return [];
  return plushCartBundleRemovalLineKeys(cart, idx + 1);
}

function plushCartBundleRemovalLineKeysByLineKey(cart, lineKey) {
  if (!cart || !Array.isArray(cart.items) || lineKey == null || lineKey === '') return [];
  var idx = -1;
  for (var j = 0; j < cart.items.length; j++) {
    if (String(cart.items[j].key) === String(lineKey)) {
      idx = j;
      break;
    }
  }
  if (idx < 0) return [];
  return plushCartBundleRemovalLineKeys(cart, idx + 1);
}

window.plushCartBundleRemovalUpdates = plushCartBundleRemovalUpdates;
window.plushCartBundleRemovalUpdatesByVariant = plushCartBundleRemovalUpdatesByVariant;
window.plushCartBundleRemovalLineKeys = plushCartBundleRemovalLineKeys;
window.plushCartBundleRemovalLineKeysByVariant = plushCartBundleRemovalLineKeysByVariant;
window.plushCartBundleRemovalLineKeysByLineKey = plushCartBundleRemovalLineKeysByLineKey;
